
namespace Matrix {

    var orgCreateSlickContainer = Serenity.EntityGrid.prototype["createSlickContainer"];
    Serenity.EntityGrid.prototype["createSlickContainer"] = function () {

        this.element.addClass('route-handler')
            .off('handleroute.' + this.uniqueName)
            .on('handleroute.' + this.uniqueName, (e: JQueryEventObject, arg: any) => {
                if (!!arg.handled)
                    return;

                if (!!(arg.route === 'new')) {
                    arg.handled = true;
                    this.addButtonClick();
                    return;
                }

                var oldRequests = jQuery["active"];

                var parts = arg.route.split('/');
                if (!!(parts.length === 2 && parts[0] === 'edit')) {
                    arg.handled = true;
                    this.editItem(parts[1]);
                }
                else if (!!(parts.length === 2 && parts[1] === 'new')) {
                    arg.handled = true;
                    this.editItemOfType(Q.cast(parts[0], String), null);
                }
                else if (!!(parts.length === 3 && parts[1] === 'edit')) {
                    arg.handled = true;
                    this.editItemOfType(Q.cast(parts[0], String), parts[2]);
                }
                else
                    return;

                if (jQuery["active"] > oldRequests && arg.handled && arg.index >= 0 && arg.index < arg.parts.length - 1) {
                    $(document).one('ajaxStop', () => {
                        setTimeout(() => Q.Router.resolve('#' + arg.parts.join('/+/')), 1);
                    });
                }
                
            });

        return orgCreateSlickContainer.apply(this);
    };


}